import type { RegistrationAction, RegistrationState } from "./types";

const MAX_STEP = 1;

export function createInitialState(
  eventSessionUuid: string,
): RegistrationState {
  return {
    currentStep: 0,
    eventInfo: null,
    eventSessionUuid,
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    groupNotes: "",
    attendees: [],
    voucherQuantity: 0,
    discountCode: null,
    discountValueType: null,
    discountRawValue: 0,
    adminDiscountType: null,
    adminDiscountValue: 0,
    adminDiscountReason: "",
    isLoading: true,
    error: null,
  };
}

export function registrationReducer(
  state: RegistrationState,
  action: RegistrationAction,
): RegistrationState {
  switch (action.type) {
    case "SET_STEP":
      return {
        ...state,
        currentStep: Math.max(0, Math.min(action.step, MAX_STEP)),
      };
    case "NEXT_STEP":
      return {
        ...state,
        currentStep: Math.min(state.currentStep + 1, MAX_STEP),
      };
    case "PREV_STEP":
      return { ...state, currentStep: Math.max(state.currentStep - 1, 0) };
    case "SET_EVENT_INFO":
      return { ...state, eventInfo: action.info };
    case "UPDATE_CONTACT":
      return { ...state, ...action.data };
    case "SET_ATTENDEES":
      return { ...state, attendees: action.attendees };
    case "SET_VOUCHER":
      return { ...state, voucherQuantity: action.quantity };
    case "SET_DISCOUNT_CODE":
      return {
        ...state,
        discountCode: action.code,
        discountValueType: action.valueType,
        discountRawValue: action.value,
      };
    case "SET_ADMIN_DISCOUNT":
      return {
        ...state,
        adminDiscountType: action.discountType,
        adminDiscountValue: action.value,
        adminDiscountReason: action.reason,
      };
    case "UPDATE_AVAILABLE_SEATS":
      return {
        ...state,
        eventInfo: state.eventInfo
          ? { ...state.eventInfo, availableSeats: action.seats }
          : state.eventInfo,
      };
    case "SET_LOADING":
      return { ...state, isLoading: action.loading };
    case "SET_ERROR":
      return { ...state, error: action.error };
    case "RESET_FLOW":
      return createInitialState(state.eventSessionUuid);
    default:
      return state;
  }
}
